import React from 'react';
import type { TaskType } from '../../../../types';

interface TaskTypeFilterProps {
  taskTypes: TaskType[];
  selectedTypeId: string | null;
  onTypeSelect: (typeId: string | null) => void;
}

export const TaskTypeFilter: React.FC<TaskTypeFilterProps> = ({
  taskTypes,
  selectedTypeId,
  onTypeSelect
}) => {
  return (
    <div className="task-type-filter-sidebar">
      {/* 全部选项 */}
      <div
        className={`task-type-tab ${selectedTypeId === null ? 'active' : ''}`}
        onClick={() => onTypeSelect(null)}
      >
        <div className="tab-text">全部</div>
      </div>

      {/* 各个任务类型标签 */}
      {taskTypes.map(taskType => (
        <div
          key={taskType.id}
          className={`task-type-tab ${selectedTypeId === taskType.id ? 'active' : ''}`}
          style={{ 
            '--tab-color': taskType.color 
          } as React.CSSProperties}
          onClick={() => onTypeSelect(taskType.id)}
        >
          <div className="tab-text">
            {taskType.name}
          </div>
          {taskType.icon && (
            <div className="tab-icon">
              {taskType.icon}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};